/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeneticsReportResponseDto } from './GeneticsReportResponseDto';
import {
    GeneticsReportResponseDtoFromJSON,
    GeneticsReportResponseDtoFromJSONTyped,
    GeneticsReportResponseDtoToJSON,
    GeneticsReportResponseDtoToJSONTyped,
} from './GeneticsReportResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface GeneticsReportsListResponseDto
 */
export interface GeneticsReportsListResponseDto {
    /**
     * List of genetics reports
     * @type {Array<GeneticsReportResponseDto>}
     * @memberof GeneticsReportsListResponseDto
     */
    data: Array<GeneticsReportResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationDto}
     * @memberof GeneticsReportsListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the GeneticsReportsListResponseDto interface.
 */
export function instanceOfGeneticsReportsListResponseDto(value: object): value is GeneticsReportsListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function GeneticsReportsListResponseDtoFromJSON(json: any): GeneticsReportsListResponseDto {
    return GeneticsReportsListResponseDtoFromJSONTyped(json, false);
}

export function GeneticsReportsListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneticsReportsListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(GeneticsReportResponseDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function GeneticsReportsListResponseDtoToJSON(json: any): GeneticsReportsListResponseDto {
    return GeneticsReportsListResponseDtoToJSONTyped(json, false);
}

export function GeneticsReportsListResponseDtoToJSONTyped(value?: GeneticsReportsListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(GeneticsReportResponseDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

